module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/fails.js
// module id = 1
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35